export const aboutData = {
    title: "Who I am",
    description1: "My name's Gemechu. I'm a full stack software developer",
    description2: "I work as a software developer. I enjoy turning ideas into real things using computer code. It's like solving puzzles and making technology that people can use. Every day is a chance for me to learn and get better at what I do. I like the challenge and I'm always excited to create new things with code.",
    image: 1
}